module.exports = __webpack_public_path__ + "img/chat_logo.3b75fa1f.svg";